import { getSettings } from "@api";
import { Modal } from "@components";
import React, { useEffect, useState } from "react";
import { CssBaseline } from "@material-ui/core";
import { useSelector } from "react-redux";
import { State } from "@store";
import { GEARS_TOKEN } from "@constants";
import { store } from "@store";

interface Props {
  closeModal: () => void;
}

export const UserGuideModal: React.FC<Props> = ({ closeModal }) => {
  const [guides, setGuides] = useState<string>("");
  const { USER_GUIDE_MODAL_OPEN } = useSelector((state: State) => state.flags);
  const gearsToken = sessionStorage.getItem(GEARS_TOKEN);
  const { user } = store.getState();
  useEffect(() => {
    if (user != null) {
      getSettings()
        .then((settings) => {
          setGuides(settings.userGuideTemplate);
        })
        .catch((err) => console.error(err));
    }
  }, [USER_GUIDE_MODAL_OPEN]);

  return (
    <Modal
      isOpen={USER_GUIDE_MODAL_OPEN}
      closeModal={closeModal}
      title="User Guides"
    >
      <CssBaseline>
        <div dangerouslySetInnerHTML={{ __html: guides }} />
      </CssBaseline>
    </Modal>
  );
};
